<div class="w-full max-w-3xl">

  <!-- Section -->
  <div class="w-full">
    <div class="text-xl">Change your password</div>
    @if (isPasswordUser) {
      <div class="text-secondary">
        You will be redirected to a secure page to change your password.
      </div>
    } @else {
      <div class="text-secondary">
        Your password is managed by your organization and cannot be changed here.
      </div>
    }
  </div>

  @if (isPasswordUser) {
    <div class="flex items-center mt-8">
      <button mat-flat-button type="button" [color]="'primary'" [disabled]="redirecting"
        (click)="changePasswordOkta()">
        @if (redirecting) {
          <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
        } @else {
          <span>Change password</span>
        }
      </button>
      @if (flashMessage === 'error') {
        <div class="flex items-center ml-4">
          <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
          <span class="ml-2">Could not start the password change, try again or contact support.</span>
        </div>
      }
    </div>
  }

</div>
